export default state => state.requests.websocket;
